/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { UseRoute } from "./config/UseRoutes";
import { LoginContext } from "./helpers/LoginContext";
import { PlatformAdminProvider } from "./context/PlatformAdminContext";
import PlatformAdminChrome from "pages/PlatformAdmin/layout/PlatformAdminChrome";
import { apiPostRequest } from "./helpers/Requests";
import {
  getRefreshToken,
  // getToken,
  // setExpireTime,
  setToken,
} from "./helpers/Tokens";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, Slide, toast } from "react-toastify";
// import CpModal from "./components/Modals/CPModal/CpModal";
import ToastMessage from "./components/common/Toaster/ToastMessage";
import pusher from "components/common/NotificationDropDown/Pusher";
import { getSpSetting } from "store/selector/sp.selector";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "store/selector/auth.selector";
import { NOTIFICATION_IDS } from "store/constants";
import {
  roleAuthenticateUserRequest,
  payrollAuthenticationUpdateLocally,
  payrollExportCallback,
  authenticatedUser,
} from "store/actions/auth.actions";
import { showToast } from "store/actions/general.actions";
import { TOAST_TYPE, USER_ROLE } from "Constants/constant";
import { getWorkerTimeSheetExportList } from "store/selector/rostering.selector";
import {
  roleAccess,
  applyRolePermissionIdsFromBroadcast,
} from "helpers/RolesPermission";
import GetItemFromLocalstorage from "Utils/GetItemFromLocalstorage";
import { currentLoggedInIdAndUUID, parseBooleanVal } from "Utils/utils";
import { mergeOrgAiFromPusherMessage } from "helpers/spAiFeatureAccess";
import VertexBanner from "components/common/Banner/Banner";
import JourneyTracker from "components/common/JourneyTracker";
import { Vertex360CopilotFloatingAssistant } from "components/Vertex360Copilot";
import AiEnablementNotice from "components/AiEnablement/AiEnablementNotice.jsx";
import api from "store/services/sp.services";
import useDefaultPaymentMethod from "hooks/useDefaultPaymentMethod";
import TrialExpireModal from "components/Modals/TrialExpiredModal/TrialExpireModal";
import GracePeriodModal from "components/Modals/GracePeriodModal/GracePeriodModal";
import useGracePeriodOverHook from "hooks/useGracePeriodHook";
import { participantUpdatePusherReceived } from "store/actions/participant.actions";
import { careWatchUpdatedPusherReceived } from "store/actions/careWatch.actions";
import { bulkAnalysePusherReceived } from "store/actions/bulkAnalyse.actions";
import { animateScroll as scroll } from "react-scroll";
import {
  getXeroSubscriptionPusherData,
  refreshPaymentSetting,
} from "store/actions/sp.actions";
const App = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isUserGracePeriodOver = useGracePeriodOverHook();
  // const isUserGracePeriodOver = true;

  var refreshToken;
  const [sideBarPadding, setSideBarPadding] = useState(false);
  const currentSpUser = useSelector(getSpSetting);
  const currentLoggedInUser = useSelector(getUser);

  const workerExportListSelector = useSelector(getWorkerTimeSheetExportList);

  const {} = useDefaultPaymentMethod();

  const dispatch = useDispatch();

  const [refreshNavigations, setRefreshNavigations] = useState(0);

  const refreshPermissionsHandler = () => {
    setRefreshNavigations((prevState) => !prevState);
  };

  useEffect(() => {
    window.addEventListener("refreshPermissions", refreshPermissionsHandler);
    return () => {
      window.removeEventListener(
        "refreshPermissions",
        refreshPermissionsHandler
      );
    };
  }, []);

  // Refresh payment setting (participant limit status, read-only warning) on each page load.
  // Skip workers (no SP Stripe routes) and platform staff (super_admin has no tenant billing context).
  // Subscription routes refresh billing via StripeTabs / subscription components — avoid a duplicate fetch + re-render on entry.
  useEffect(() => {
    const path = location.pathname || "";
    const isSubscriptionBillingRoute =
      path === "/subscription" || path.startsWith("/subscription/");

    if (
      localStorage.getItem("accessToken") &&
      currentLoggedInUser?.id &&
      currentLoggedInUser?.userType !== USER_ROLE.Sp_Standard_User &&
      currentLoggedInUser?.userType !== USER_ROLE.Super_Admin &&
      !isSubscriptionBillingRoute
    ) {
      dispatch(refreshPaymentSetting());
    }
  }, [location.pathname, currentLoggedInUser?.id, currentLoggedInUser?.userType, dispatch]);

  useEffect(() => {
    const base =
      "https://vertex360softwaresolution-vertex-360.odoo.com/im_livechat";
    const injected = { loader: null, assets: null };
    const loader = document.createElement("script");
    injected.loader = loader;
    loader.type = "text/javascript";
    loader.src = `${base}/loader/4`;
    loader.onload = () => {
      const assets = document.createElement("script");
      injected.assets = assets;
      assets.type = "text/javascript";
      assets.src = `${base}/assets_embed.js`;
      document.body.appendChild(assets);
    };
    document.body.appendChild(loader);
    return () => {
      if (injected.assets?.parentNode) {
        injected.assets.parentNode.removeChild(injected.assets);
      }
      if (injected.loader?.parentNode) {
        injected.loader.parentNode.removeChild(injected.loader);
      }
      document.querySelectorAll(".o-livechat-root").forEach((el) => el.remove());
    };
  }, []);

  const clearSession = () => {
    clearTimeout(refreshToken);
  };

  // const [warnModel,setWarnModel]=useState(true)
  // const [notify, setNotify] = useState(true);

  // const myFunction = () => {
  //   const current = moment().format("HH:mm");
  //   // const current = moment();
  //   const { logInTime, warnTime, logoutTime } = getExpireTime();

  //   if (current === logoutTime) {
  //     dispatch(callLogout());
  //   } else if (current === warnTime && notify) {
  //     setNotify(false);
  //     dispatch(
  //       showMessageBoxForTimeExpiry({
  //         title: "SessionExpire",
  //         message: "5 min left in session expiry. Do You Want to login again",
  //         type: true,
  //       })
  //     );
  //   } else if (notify) {
  //     setNotify(false);
  //   }
  // };
  // setInterval(myFunction, 120000);

  const refreshTokenTimeout = (expirationTime) => {
    refreshToken = setTimeout(() => {
      refreshTokenRequest();
    }, expirationTime * 1000);
  };

  const refreshTokenRequest = async () => {
    const token = getRefreshToken();
    const data = {
      token,
    };
    if (!token) {
      return;
    }
    try {
      let res = await apiPostRequest("refresh-token", data);
      if (res.status !== 200) {
        console.log("Throw Some Errors");
      }
      if (res.status === 200) {
        setToken(res.data.data.AccessToken);
        const expirationDate = new Date(new Date().getTime() + 3600 * 1000);
        const refreshTokenDate = new Date(new Date().getTime() + 3600 * 1000);
        localStorage.setItem("expirationDate", expirationDate);
        localStorage.setItem("refreshTokenDate", refreshTokenDate);
        navigate("/dashboard");
      }
    } catch (err) {
      console.log(err);
    }
  };

  // const handleExtend = () => {
  //   const logInTime = moment().format("HH:mm");
  //   const warnTime = moment().add(120000, "milliseconds").format("HH:mm");
  //   const logoutTime = moment().add(7200000, "milliseconds").format("HH:mm");
  //   setExpireTime({ logInTime, warnTime, logoutTime });
  //   setIsWarnModel(false);
  // };

  // const [isWarnModel, setIsWarnModel] = useState();

  // const handleClose = () => {
  //   setIsWarnModel(false);
  // };

  // useEffect(() => {
  //   if (isRefreshPusher) {
  //     pusherUpdate();
  //   }
  // }, [isRefreshPusher]);

  const unSubscribeChannels = () => {
    if (pusher) {
      const userObjForSp = currentLoggedInIdAndUUID(true);
      const userObjForNonSp = currentLoggedInIdAndUUID(false);

      if (userObjForSp) {
        pusher.unsubscribe(`payroll-${userObjForSp.uuid}`);
      }
      const sp_id =
        currentLoggedInUser?.sp_id || currentLoggedInUser?.service_provider?.id;

      if (sp_id) {
        pusher.unsubscribe(`role-sp-${sp_id}`);
        pusher.unsubscribe(`stripe-${sp_id}`);
        pusher.unsubscribe(`leave-sp-${sp_id}`);
      }

      // if (currentSpUser) pusher.unsubscribe(`payroll-${currentSpUser.uuid}`);
      // if (currentLoggedInUser) {
      //   pusher.unsubscribe(`role-sp-${currentLoggedInUser.sp_id}`);
      // }
    }
  };

  useEffect(() => {
    pusherUpdate();

    return () => {
      if (pusher) {
        const userObjForSp = currentLoggedInIdAndUUID(true);
        // const userObjForNonSp = currentLoggedInIdAndUUID(false);
        if (userObjForSp) {
          pusher.unsubscribe(`payroll-${userObjForSp.uuid}`);
        }
        const sp_id =
          currentLoggedInUser?.sp_id ||
          currentLoggedInUser?.service_provider?.id;

        if (sp_id) {
          pusher.unsubscribe(`role-sp-${sp_id}`);
          pusher.unsubscribe(`stripe-${sp_id}`);
          pusher.unsubscribe(`participant-sp-${sp_id}`);
          pusher.unsubscribe(`xero-subscription-${sp_id}`);
          pusher.unsubscribe(`leave-sp-${sp_id}`);
        }

        // if (currentSpUser) pusher.unsubscribe(`payroll-${currentSpUser.uuid}`);
        // if (currentLoggedInUser) {
        //   pusher.unsubscribe(`role-sp-${currentLoggedInUser.sp_id}`);
        // }
      }
    };
  }, []);

  useEffect(() => pusherUpdate(), [currentSpUser, currentLoggedInUser]);

  const payrollToster = (obj) => {
    if (
      obj.message &&
      obj.message.key === NOTIFICATION_IDS.PAYROLL_TIMESHEET_CALLBACK
    ) {
      if (
        workerExportListSelector &&
        workerExportListSelector.length > 0 &&
        obj.message &&
        obj.message?.worker_uuid
      ) {
        const index = workerExportListSelector.findIndex(
          (x) => x.uuid === obj.message?.worker_uuid
        );
        if (index !== -1) {
          dispatch(
            showToast({
              type:
                obj.message?.status === true
                  ? TOAST_TYPE.SUCCESS
                  : TOAST_TYPE.ERROR,
              title: obj.message?.message || "",
            })
          );
        }
      }
    }
  };

  const pusherUpdate = async () => {
    if (!currentLoggedInUser || !currentLoggedInUser.uuid) {
      return;
    }
    const user = GetItemFromLocalstorage("user");
    if (user === null) {
      return;
    }

    const userObjForSp = currentLoggedInIdAndUUID(false);
    const userObjForNonSp = currentLoggedInIdAndUUID(false);

    const sp_id =
      currentLoggedInUser?.sp_id || currentLoggedInUser?.service_provider?.id;

    let selectedSpId = sp_id;
    if (!selectedSpId) {
      try {
        const cachedProvider = JSON.parse(
          localStorage.getItem("selectedProvider") || "null"
        );
        selectedSpId = cachedProvider?.value || null;
      } catch (e) {
        selectedSpId = null;
      }
    }

    //need to discuss
    const subscribedChannels = Object.keys(pusher?.channels?.channels);

    if (userObjForSp) {
      const payrollChannelName = `payroll-${userObjForSp.uuid}`;
      if (!subscribedChannels.includes(payrollChannelName)) {
        const payrollChannel = pusher.subscribe(payrollChannelName);

        payrollChannel.bind("notify", (obj) => {
         
          if (
            obj.message &&
            obj.message.key === NOTIFICATION_IDS.PAYROLL_AUTHENTICATION
          ) {
            dispatch(
              payrollAuthenticationUpdateLocally({
                ...obj.message,
              })
            );
          }
          if (
            obj.message &&
            obj.message.key === NOTIFICATION_IDS.PAYROLL_TIMESHEET_CALLBACK
          ) {
            payrollToster({ ...obj });
            dispatch(payrollExportCallback({ ...obj.message }));
          }
        });
      }

      // Participant Update
      const spParticipantChannelName = `participant-sp-${sp_id}`;
      if (!subscribedChannels.includes(spParticipantChannelName)) {
        const spParticipantChannel = pusher.subscribe(spParticipantChannelName);
        spParticipantChannel.bind("notify", async (obj) => {
          if (
            obj.message &&
            obj.message.key === NOTIFICATION_IDS.PARTICIPANT_UPDATE
          ) {
            dispatch(participantUpdatePusherReceived(obj.message.data));
          }
        });
      }

      // Leave request badge updates (worker portal create/update/delete)
      const leaveChannelName = `leave-sp-${selectedSpId}`;
      if (selectedSpId && !subscribedChannels.includes(leaveChannelName)) {
        const leaveChannel = pusher.subscribe(leaveChannelName);
        const handleLeaveNotify = (obj) => {
          const message = obj?.message || obj;
          if (message && message.key === NOTIFICATION_IDS.LEAVE_REQUEST_UPDATE) {
            window.dispatchEvent(
              new CustomEvent("vertex360:leave-request-notify", {
                detail: message,
              })
            );
          }
        };
        // Laravel Echo uses ".notify"; raw Pusher may emit "notify"
        leaveChannel.bind("notify", handleLeaveNotify);
        leaveChannel.bind(".notify", handleLeaveNotify);
      }

      if (roleAccess([USER_ROLE.Sp_Admin])) {
        //Stripe
        const StripeChannelName = `stripe-${sp_id}`;
        if (!subscribedChannels.includes(StripeChannelName)) {
          const stripeChannel = pusher.subscribe(StripeChannelName);
          stripeChannel.bind("notify", async (obj) => {
            if (
              obj.message &&
              obj.message.key === NOTIFICATION_IDS.STRIPE_SUBSCRIPTION
            ) {
              if (obj.message.status === "failed") {
                const response = await api.stirpeGetDefaultPaymentMethod();
                if (response?.payment_setting) {
                  const user = await GetItemFromLocalstorage("user");
                  if (user) {
                    user.payment_setting = response?.payment_setting;
                    localStorage.setItem("user", JSON.stringify(user));
                    dispatch(authenticatedUser(user));
                  }
                }
                toast.error(
                  response?.payment_setting?.errorMessage || "Payment Failed!"
                );
              } else if (obj.message.status === "success") {
                toast.success(obj.message.message);
                const response = await api.stirpeGetDefaultPaymentMethod();
                const user = await GetItemFromLocalstorage("user");
                if (user) {
                  user.payment_setting = response?.payment_setting;
                  localStorage.setItem("user", JSON.stringify(user));
                  dispatch(authenticatedUser(user));
                }
                window.dispatchEvent(
                  new CustomEvent("vertex360:stripe-subscription-updated")
                );
              }
            } else if (
              obj.message &&
              obj.message.key === NOTIFICATION_IDS.AI_TOP_UP
            ) {
              window.dispatchEvent(
                new CustomEvent("vertex360:ai-top-up-notify", {
                  detail: obj.message,
                })
              );
            }
          });
        }

         const XeroSubscriptionChannelName = `xero-subscription-${sp_id}`;
  if (!subscribedChannels.includes(XeroSubscriptionChannelName)) {
 
const xeroSubscriptionChannel= pusher.subscribe(XeroSubscriptionChannelName);
xeroSubscriptionChannel.bind("notify", async (obj) => {
if (obj.message && obj.message.key === NOTIFICATION_IDS.XERO_SUBSCRIPTION) {
  
  dispatch(getXeroSubscriptionPusherData(obj.message));

}
})

  }
      }
    }

    if (sp_id) {
      const roleChannelName = `role-sp-${sp_id}`;
      if (!subscribedChannels.includes(roleChannelName)) {
        const roleChannel = pusher.subscribe(roleChannelName);
        roleChannel.bind("notify", (obj) => {
          if (!obj?.message?.key) {
            return;
          }
          if (obj.message.key === NOTIFICATION_IDS.ROLE_UPDATE) {
            const user = GetItemFromLocalstorage("user");
            const roleId = obj.message.role_id;
            const isOurRole =
              roleId == null ||
              user?.role_id == null ||
              String(user.role_id) === String(roleId);
            if (isOurRole) {
              // Patch localStorage immediately from permission_ids (no hard refresh).
              const patched = applyRolePermissionIdsFromBroadcast(
                roleId ?? user?.role_id,
                obj.message.permission_ids
              );
              if (patched) {
                dispatch(authenticatedUser(patched));
              }
              // Background sync if session was missing new permission rows.
              dispatch(roleAuthenticateUserRequest());
            }
          }
          if (obj.message.key === NOTIFICATION_IDS.AI_ORG_UPDATE) {
            mergeOrgAiFromPusherMessage(obj.message);
          }
          if (obj.message.key === NOTIFICATION_IDS.CARE_WATCH_UPDATED) {
            dispatch(careWatchUpdatedPusherReceived(obj.message));
          }
          if (
            obj.message.key === NOTIFICATION_IDS.BULK_ANALYSE_UPDATED ||
            obj.message.key === NOTIFICATION_IDS.BULK_ANALYSE_FINISHED
          ) {
            dispatch(bulkAnalysePusherReceived(obj.message));
          }
        });
      }
    }
  };

  const [isDisplayBanner, setIsDisplayBanner] = useState(false);
  const [isTrialChoosePlanBtnClick, setIsTrailChoosePlanBtnClick] = useState(0);
  const hideTrialBannerOnAuthPages = [
    "/family-set-password",
    "/reset-password",
    "/forget-password",
    "/member-invitation",
    "/sp-invitation",
  ].some(
    (path) =>
      location.pathname === path || location.pathname.startsWith(`${path}/`)
  );

  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  return (
    <>
      {currentLoggedInUser &&
        "id" in currentLoggedInUser &&
        roleAccess([USER_ROLE.Sp_Admin]) &&
        parseBooleanVal(currentLoggedInUser?.payment_setting?.wildcard) ===
          false &&
        isDisplayBanner &&
        !hideTrialBannerOnAuthPages && (
          <VertexBanner
            setIsTrailChoosePlanBtnClick={setIsTrailChoosePlanBtnClick}
          />
        )}
      <LoginContext.Provider
        value={{
          refreshTokenTimeout,
          clearSession,
          setSideBarPadding,
          sideBarPadding,
          refreshNavigations,
          setRefreshNavigations,
          isUserGracePeriodOver,
          unSubscribeChannels,
          isTrialChoosePlanBtnClick,
          scrollToTop,
        }}
      >
        <PlatformAdminProvider>
          <PlatformAdminChrome />
          <JourneyTracker>
            <UseRoute setIsDisplayBanner={setIsDisplayBanner} />
          </JourneyTracker>
        </PlatformAdminProvider>
      </LoginContext.Provider>
      <AiEnablementNotice />
      <Vertex360CopilotFloatingAssistant />
      {/* <Confirmation /> */}
      {/* <CpModalExpiryLougOut /> */}
      <ToastMessage />
      <ToastContainer
        position='top-right'
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        transition={Slide}
        style={{ zIndex: 10100 }}
      />
      {isDisplayBanner &&
        !hideTrialBannerOnAuthPages &&
        roleAccess([USER_ROLE.Sp_Admin]) && (
        <>
          <TrialExpireModal />
          <GracePeriodModal />
        </>
      )}
    </>
  );
};
export default App;
